export default __webpack_public_path__ + "f37ddbeefffb4ad55548c3a3905d7f38.png";